<template>
<v-app>
  <v-overlay v-model="pageLoaded" opacity='0.9' color='rgba(255, 255, 255 , 1)'>
    <v-img src='https://www.myq.gr/ext_files/prepaid/q/media/loading_orange.gif'></v-img>
  </v-overlay>
  <v-dialog persistent v-model="$store.getters.getError" width="400px">
    <v-card class="text-center pa-4">
      <h2>{{$store.getters.getErrorMessage}}</h2>
      <v-btn class="mt-3" :href="dashboardLink">
      {{$store.getters.getLocale==='gr' ? 'Πίσω στο Dashboard':'Back to Dashboard'}}
      </v-btn>
    </v-card>
  </v-dialog>
    <v-app-bar
      app
      color="rgb(14, 40, 184)"
      dark
      extended
      extension-height="16"
    >
      <div class="d-flex align-center">
        <a :href='qLink'>
          <v-img
            class="ml-15 mt-12"
            contain
            src="/ext_files/prepaid/q/media/myqlogo.svg"
            transition="scale-transition"
            width="70"
          />
        </a>
      </div>

      <!-- <v-spacer></v-spacer> -->
    </v-app-bar>

    <v-main class="body-section">
      <Dashboard v-if="isEligible"/>
      <Requirements v-else-if="isEligible === false"/>
    </v-main>
  </v-app>
</template>

<script>
// @ is an alias to /src
import Dashboard from '@/components/Dashboard.vue'
import Requirements from '@/components/Requirements.vue'

// import HelloWorld from '@/components/HelloWorld.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: { Dashboard, Requirements },
  name: 'App',
  data () {
    return {
      loading: true,
      msisdn: '',
      email: '',
      mailToCopy: '',
      qLink: '',
    }
  },
  computed: {
    dashboardLink(){
      if(this.$store.getters.getLocale==='gr'){
        return '/gr/myq/#/to-upoloipo-mou'
      }else{
        return '/en/myq/#/balance'
      }
    },
    isEligible () {
      return this.getIsEligible()
    },
    pageLoaded (){
      return !this.getPageLoaded()
    }
  },
  watch: {
    pageLoaded() {
    }
  },
  methods: {
    ...mapActions([
      'loadMessages',
      'createInvitation',
      'constructCallerInfo'
    ]),
    ...mapGetters([
      'getIsEligible',
      'getShareIdUrl',
      'getPageLoaded'
    ])
  },
  async mounted () {
    // self.showLoader()
    if (readCookie("prepaidDL") !== null) {
      deleteCookie("prepaidDL");
    }

    let locale = 'el_GR'
    if (document.getElementsByTagName('body')[0].dataset.locale !== undefined) {
      locale = document.getElementsByTagName('body')[0].dataset.locale
      if (locale === 'en_US') {
        this.qLink = '/en/'
        this.$store.commit('setLocale', 'en')
      }else{
        this.qLink = '/gr/'
        this.$store.commit('setLocale', 'gr')
      }
    }

    const self = this
    if (sessionStorage.messages && (JSON.parse(sessionStorage.messages))[locale]) {
      self.$store.commit('setMessages', JSON.parse(sessionStorage.messages)[locale])
    } else {
      self.loadMessages(locale)
    }

    this.constructCallerInfo(locale)

    this.msisdn = document.getElementById('user-info').getAttribute('data-msisdn')
    this.email = document.getElementById('user-info').getAttribute('data-email')
    this.$store.commit('setMsisdn', this.msisdn)
    this.$store.commit('setEmail', this.email)
    this.createInvitation().then(() => {
      
    })
  }
}
</script>

<style scoped>
@import './assets/styles/style.css';
</style>

